import axios from 'axios';
import { APIS, HOST } from '../constants/apis';
import axiosInstance from '../utils/axios';

export const gatShopMe = async (token: string) => {
  const respone = await axios({
    method: 'get',
    url: HOST.localUrl + APIS.getShopMe,
    headers: { Authorization: `Bearer ${token}` },
  })
    .then(function (response) {
      return response;
    })
    .catch(function (response) {
      return response;
    });
  return respone;
};

export async function getShopMeReward(page: number) {
  const respone = await axiosInstance
    .get(
      APIS.getShopMeReward +
        '?page=' +
        page +
        '&limit=' +
        (window.innerHeight < 700 ? 4 : 5)
    )
    .then(function (response) {
      return response;
    })
    .catch(function (response) {
      return response;
    });
  return respone;
}
